var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Iframe',{attrs:{"sermon":_vm.sermon}}),_c('Sermons',{attrs:{"sermons":_vm.sermons},on:{"selected":_vm.updateSelected}}),_c('Verse'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }